import { Text, Headline } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { DISPLAY_SIZE } from '../../common/global.style.constants';
import { UnifiedTheme } from '../../../FeatureApp';

const device = {
  desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
  largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
  smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
  mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
  tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
  smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};

export const ModalContainer = styled.div`
  position: absolute;
  background-blend-mode: darken;
  /* background-color: rgba(0, 0, 0, 0.7); */
  height: 100%;
  width: 100%;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  align-items: flex-start;
  background-color: ${(props: UnifiedTheme) =>
    props.theme.sys.color.canvas[200] || props.theme.sys.color.canvas.default};
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: space-between;
  left: 50%;
  overflow-y: auto;
  padding: 72px 52px 52px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;

  button {
    span {
      width: max-content;
    }
  }

  @media ${device.tablet} {
    width: 600px;
  }
`;

export const Heading = styled(Headline)`
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.003px;
  line-height: 48px;
  margin: 0;
`;

export const BodyText = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.003px;
  line-height: 24px;
  margin: 0;
`;

export const BodyTextContainer = styled.div<UnifiedTheme>`
  display: grid;
  gap: ${(props) => props.theme?.sys?.space?.md || '32px'};
  margin: ${(props) => props.theme?.sys?.space?.md || '32px'} 0;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: 4px;
  top: 4px;
`;

export const ButtonGroupContainer = styled.div`
  button {
    width: auto;
    min-width: fit-content;

    span {
      width: auto;
    }
  }
`;
